/**
 * @vuepress
 * ---
 * title: MinimalCatalog
 * ---
 */
/**
 * @class MinimalCatalog
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

import Transformer from '../transformer'

class MinimalCatalog extends Transformer {
  static fetch({
    id,
    slug,
    name
  }) {
    return {
      id,
      slug,
      name }
  }
}

export default MinimalCatalog
